/*
* @Author: tangke
* @Date: 2019-01-19 11:56:57
 * @Last Modified by: others
 * @Last Modified time: 2019-01-25 15:30:12
*/

<template>
  <v-container fluid
               fill-height
               class="login">
    <vue-particles class="particles-class"
                   color="#dedede"
                   :particleOpacity="0.5"
                   :particlesNumber="80"
                   shapeType="circle"
                   :particleSize="4"
                   linesColor="#dedede"
                   :linesWidth="1"
                   :lineLinked="true"
                   :lineOpacity="0.4"
                   :linesDistance="150"
                   :moveSpeed="3"
                   :hoverEffect="true"
                   hoverMode="grab"
                   :clickEffect="true"
                   clickMode="push">
    </vue-particles>
    <v-layout align-center
              justify-center
              class="login-box">
      <v-flex xs12
              sm8
              md4
              lg3>
        <v-card flat
                color="rgba(255, 255, 255, 0.5)">
          <v-toolbar flat
                     class="transparent">
            <v-img alt="登录logo图"
                   :src="title"
                   aspect-ratio="4.82"
                   width="188"
                   max-width="188"
                   height="39"
                   position="left center"
                   contain></v-img>
            <v-spacer></v-spacer>
            <v-toolbar-title>Tutors' System</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field prepend-icon="person"
                            color="teal"
                            name="login"
                            label="用户名"
                            type="text"
                            v-model="loginForm.username"></v-text-field>
              <v-text-field prepend-icon="lock"
                            color="teal"
                            name="password"
                            label="密码"
                            id="password"
                            type="password"
                            v-model="loginForm.password"></v-text-field>
              <v-layout row
                        wrap>
                <v-flex xs6>
                  <v-checkbox v-model="loginForm.isAgree"
                              color="teal"
                              label="Remember the account">
                    <div slot="label"
                         class="body-2">Remember the account</div>
                  </v-checkbox>
                </v-flex>
                <v-flex xs6>
                  <v-checkbox v-model="loginForm.isRemeber"
                              color="teal"
                              label="Remember the account">
                    <div slot="label"
                         class="body-2">Remember the account</div>
                  </v-checkbox>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn block
                   color="teal"
                   :disabled="isLoading"
                   @click="login"
                   class="text-none">
              <v-progress-circular indeterminate
                                   color="white"
                                   v-show="isLoading"></v-progress-circular>
              <span v-show="!isLoading"
                    class="white--text">
                Sign Ins
              </span>
            </v-btn>
          </v-card-actions>
          <v-card-text>
            <v-layout row
                      justify-space-between
                      wrap>
              <v-flex xs6>
                <agree :agreeData="agreeData" />
              </v-flex>
              <v-flex xs2>
                <faq :faqData="faqData" />
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>

// import { loginThree } from '@/api/user'
import title from '@/assets/img/login/title.png'
import agree from '@/components/dialogs/agree.vue'
import faq from '@/components/dialogs/faq.vue'
export default {
  name: 'login',
  data: () => ({
    agreeData: {
      dialog: false
    },
    faqData: {
      faqData: false
    },
    title: title,
    loginForm: {
      username: process.env.VUE_APP_LOGIN_USER_NAME || '',
      password: process.env.VUE_APP_LOGIN_USER_PSW || ''
    },
    dialog: true,
    isLoading: false
  }),
  components: {
    agree,
    faq
  },
  mounted () {
  },
  methods: {
    login () {
      this.isLoading = true
      this.$store.dispatch('LoginByUsername', this.loginForm).then((res) => {
        this.$router.push({
          path: '/'
        })
      }).catch(() => {
        // send error msg if needed
      }).finally(() => {
        this.isLoading = false
      })
    }
  }
}
</script>
<style>
  .particles-class canvas {
    display: block;
  }
</style>
<style lang="scss" scoped>
  @import "./login";
</style>
